export const USER_ROLES = {
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

export const LEAD_STATUS = {
  NEW: 'NEW',
  IN_PROGRESS: 'IN_PROGRESS',
  MADE_OFFER: 'MADE_OFFER',
  DEAL_CLOSED_SUCCESS: 'DEAL_CLOSED_SUCCESS',
  DEAL_FAILED: 'DEAL_FAILED',
  LEAD: 'LEAD',
};
export const FORM_STATUS = {
  LEAD: 'LEAD',
  SPAM: 'SPAM',
  QUERY: 'QUERY',
};
